import { observer } from "mobx-react-lite"

import { ProjectNameMessageModel } from "@/components/Chat/NewProject/ProjectNameMessageModel.ts"
import { TextFieldMessage } from "@/components/Chat/NewProject/RepositoryUrlMessage.tsx"
import { useModel } from "@/hooks/useModel.ts"
import { useOrgContext } from "@/hooks/useRootContext.ts"


import type { ChatMessageModel } from "@/components/Chat/ChatModel.ts"
import type { AiChatMessageContent } from "@/lib/client/generated/TypeDefinitions.ts"

export const ProjectNameMessage = observer((props: {
  message: ChatMessageModel
  content: AiChatMessageContent.InitProject.ProjectName
}) => {
  const context = useOrgContext()

  const args = {
    context: context,
    value: props.content.name,
    taskId: props.message.taskId,
    editable: props.content.editable,
    placeholder: "Enter project name",
    field: "Project name:"
  }
  const model = useModel(() => new ProjectNameMessageModel(args), [args.context, args.taskId, args.value, args.editable])

  return (
    <TextFieldMessage model={model} message={props.message} />
  )
})